import { useState } from "react";
import CreateMatterForm, {
  CreateMatterFormValues
} from "../../components/CreateMatterForm/CreateMatterForm.tsx";
import { save } from "../../utils/sharepointAPI.ts";
import { saveFile } from "../../utils/sharepointAPI.ts";
import MatterSentModal from "../../components/MatterSentModal/MatterSentModal.tsx";
import { generateFileName, getEnvironment } from "../../utils/utils.ts";
import { setIsLoadingAction } from "../../actions/formActions.ts";
import { RootState } from "@/reducers/rootReducer.ts";
import { useAppDispatch, useAppSelector } from "@/hooks/storeHooks.ts";
import { FrameComponent, Loader } from "fmv-component-ui-library";
import { FrameColor } from "@/utils/enums.ts";

const CreateMatterPage = () => {
  const data = useAppSelector(state => state.application);
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(
    (state: RootState) => state.application.loadingData
  );
  const env = getEnvironment();

  const [show, setShow] = useState(false);

  const handleSubmitQuestion = async (
    matterFormValues: CreateMatterFormValues
  ) => {
    const doubleLinebreak = "\n\n";
    if (data.isLoggedIn) {
      // Om användaren är inloggad på logp kan den skicka ett ärende som direkt hamnar i VSDLS ärendehanteringssystem under "Utkast" för kundtjänst
      const urlString = `/tjansterprodukter/${env}/_api/lists/GetByTitle('Matters')/Items`;
      const newMatter = {
        __metadata: { type: "SP.Data.MattersListItem" },
        matterDescription: matterFormValues.teamcenterNumber
          ? "Ärendenummer från Teamcenter: " +
            matterFormValues.teamcenterNumber +
            doubleLinebreak +
            matterFormValues.questionContent
          : matterFormValues.questionContent,
        matterTitle: matterFormValues.questionTitle,
        clientName: matterFormValues.userName,
        clientMail: matterFormValues.email,
        status: "Utkast",
        imported: true,
        createdDate: new Date().toISOString(),
        recievedVia: "import",
        sectionId: matterFormValues.section?.value,
        questionTypeId: matterFormValues.questionType?.value,
        clientTypeId: matterFormValues.clientType?.value
      };
      try {
        dispatch(setIsLoadingAction(true));
        const response = await save(urlString, newMatter);

        const newMatterId = response.Id;

        if (newMatterId && matterFormValues.uploadedFiles) {
          const generalFiles = matterFormValues.uploadedFiles.map(
            (file: File) => {
              const modifiedFile = new File(
                [file],
                generateFileName(file.name),
                {
                  type: file.type
                }
              );

              return modifiedFile;
            }
          );
          await saveFile("MatterFiles", generalFiles, newMatterId);
        }
        setShow(true);
        dispatch(setIsLoadingAction(false));
      } catch (error) {
        console.error("Save failed", error);
      }
    } else {
      // öppna mailklienten om ärendet skapas i logistikportalen
      const mailContent = `
      Detta ärende skickas från självbetjäning kundtjänst till FMV kundtjänst verksamhetsstöd för behandling:

      Namn: ${matterFormValues.userName}
      
      E-post: ${matterFormValues.email}
      
      Målgrupp: ${
        matterFormValues.clientType
          ? matterFormValues.clientType.label
          : "Ingen målgrupp vald"
      }
      Frågeart: ${
        matterFormValues.questionType
          ? matterFormValues.questionType.label
          : "Ingen frågeart vald"
      }
      Tjänsteområde/Tekniskt system: ${
        matterFormValues.section
          ? matterFormValues.section.label
          : "Inget tjänsteområde/tekniskt system valt"
      }
      ${
        matterFormValues.teamcenterNumber &&
        "Ärendenummer från Teamcenter: " + matterFormValues.teamcenterNumber
      }
      Ärendetitel: ${matterFormValues.questionTitle}
            
      Ärendebeskrivning: ${matterFormValues.questionContent}`.replace(
        /^(\s+)(?=\S)/gm, // removes whitespace in the beggning of lines
        ""
      );
      const encodedMailContent = encodeURIComponent(mailContent);

      let href = `mailto:verksamhetsstod@fmv.se?subject=Ärende från Logistikportalen&body=${encodedMailContent}`;

      window.open(href);
    }
  };

  const handleModalClose = () => setShow(false);

  return (
    <>
      {isLoading && <Loader />}
      <MatterSentModal show={show} onHide={handleModalClose} />
      <FrameComponent
        color={FrameColor.BLUE}
        headerAlign="left"
        header="Skapa ärende"
      >
        <div className="page-container">
          <div className="info-text-container">
            <h2>
              <b>Behöver du hjälp?</b> Fyll i formuläret nedan så återkommer vi
              så snart som möjligt. För att vi ska kunna hjälpa dig på bästa
              sätt, vänligen fyll i alla obligatoriska fält så noggrant du kan.
            </h2>
          </div>
          <CreateMatterForm onSubmit={handleSubmitQuestion} />
        </div>
      </FrameComponent>
    </>
  );
};

export default CreateMatterPage;
